/* lib/academy/lessonState.js — решения внутри урока, вынесенные из плеера,
 * чтобы их можно было проверить тестом (компонентных тестов в проекте нет).
 * Два места, где UI раньше врал или заводил в тупик: окно обратной связи по
 * тарифу (ST-6) и итог теста при скрытом разборе (ST-8). */

/** Сдать ДЗ уже нельзя: окно обратной связи закрыто И проверку делает куратор.
 *  Режимы auto / auto_after_feedback сюда не попадают — там сдача
 *  автопринимается и после закрытия окна (backend services.submit_homework).
 *  Поля может не быть в ответе (старый бэкенд) — тогда false, композер остаётся. */
export function isFeedbackClosed(homework) {
  if (!homework || homework.feedback_active !== false) return false;
  return (homework.review_mode || 'curator') === 'curator';
}

/** Итог теста: {correctCount, total}. correctCount === null означает «неизвестно»
 *  — при show_correct=false бэк не отдаёт разбор (results:null), и считать по
 *  пустому массиву нельзя: так сдавший видел «Верно 0 из N — порог пройден». */
export function readQuizScore(result, quiz) {
  const total = (result && result.total != null)
    ? result.total
    : ((quiz && quiz.questions ? quiz.questions.length : 0));
  if (!result) return { correctCount: null, total };
  if (result.correct_count != null) return { correctCount: result.correct_count, total };
  if (Array.isArray(result.results)) {
    return { correctCount: result.results.filter((r) => r.correct).length, total };
  }
  return { correctCount: null, total };
}
